<template>
  <div class="container container-nav container-footer job-detail bg-gray" @click="showIndex=-1">
    <van-nav-bar title="职位详情" fixed left-arrow :z-index=999 @click-left="goBack"></van-nav-bar>

    <info :recruit="recruit" :showDistance="showDistance">
      <template #commission v-if="recruit.vleaderCommission>0">
        <p class="bg-fan c-white f11 fr" v-if="recruit.vleaderCommission>0 && recruit.jobType===2">奖励{{recruit.vleaderCommission}}元/时</p>
        <p class="bg-fan c-white f11 fr" v-if="recruit.vleaderCommission>0 && recruit.jobType===1 && !recruit.vleaderHighestCommission">奖励{{recruit.vleaderCommission}}元/时</p>
        <p class="bg-fan bg-fan-big c-white f11 fr" v-if="recruit.vleaderCommission>0 && recruit.jobType===1 && recruit.vleaderHighestCommission>0">最高奖励<br>{{recruit.vleaderHighestCommission}}元/人</p>
      </template>
      <template #count>
        <span class="f12 c-gray lb-vm">
          <!-- 招聘<span class="c-333">{{recruit.RecruitCount}}</span>人,
          已报名<span class="c-orange">{{recruit.PickCount}}</span>人 -->
        </span>
      </template>
    </info>

    <section class="bg-white mt10 mb10 detail-single-line-tabs">
      <van-tabs @click="tabChange">
        <van-tab title="职位描述">
          <template v-if="recruit.remark">
            <div class="zw-detail f12 c-333" :class="{'txt-elips3l':!showMore&&recruit.remark.length>60}"
                 v-html="remarkHtml"></div>
            <p class="txt-r pr25" v-if="recruit.remark.length>60" @click="showMore=!showMore">
              <span class="c-orange f12">{{showMore?'收起':'展开'}}</span>
              <span class="icon c-gray f14 lb-vm" :class="showMore?'icon-mup':'icon-mdown'"></span>
            </p>
          </template>
        </van-tab>
        <van-tab :title="titlePerson">
          <div class="enroll-list ptb15 mlr15 van-hairline--bottom flex all-c"
               v-for="(item,index) in personList" :key="index">
            <div class="ds-avatar txt-c mr5">
              <img :src="item.avatarUrl" v-if="item.avatarUrl"/>
              <img src="../../assets/images/common/user-photo.jpg" v-else/>
            </div>
            <div class="flex-1">
              <div>
                <span class="f14 f-b mr5 lb-vm">{{item.name || item.phone}}</span>
                <span class="ds-status f12 lb-vm pos-r" :class="employeeColor[item.status]"
                      @click.stop="showRemark(index)">{{employeeStatus[item.status]}}<span
                  class="icon icon-help c-000 f14 ml2" v-if="item.status === 12"></span>
                  <div class="refect-tip job-refect-tip pos-ab" v-show="showIndex===index">
                    <span class="dot dot-left pos-ab"></span>
                    <span class="tip-content p-normal lb-vm f12">{{item.remark}}</span>
                  </div>
                </span>
              </div>
              <p class="c-gray f12">{{formatTime(item.createTime)}}</p>
            </div>
            <div class="txt-c phone-bor fr" @click="callTel(item.phone)">
              <span class="icon icon-storePhone c-green f20"></span>
            </div>
          </div>
          <div class="look-more ptb10 txt-c f12 c-666" v-if="!finished" @click="getPersonList()">
            查看更多<span class="icon icon-mdown c-gray f14 lb-vm"></span>
          </div>
        </van-tab>
      </van-tabs>
    </section>

    <!-- 面试时间暂时隐藏，新接口未返回该数据 -->
    <!-- <section class="p15 bg-white mt10 mb10">
        <div class="ds-job-list-footer m0 bd-0">
          <div class="">
            <h3 class="pr4"><span class="f14 f-b">面试时间</span></h3>
          </div>
           <div class="flex all-t ds-address-detail p0">
            <span class="icon icon-shizhong f16 c-orange"></span>
            <div class="flex-1 f12">
               <div class="f12 lh-2">
                <span>待定</span>
              </div>
            </div>
          </div>
        </div>
    </section> -->

    <section class="p15 bg-white mt10 mb10" v-if="recruit.imgUrls && recruit.imgUrls.length">
      <h3 class="f14 f-b pb10">店铺环境</h3>
      <swiper :options="swiperOption">
        <swiper-slide v-for="(url,index) in recruit.imgUrls" :key="url">
          <img :src="url+'?x-oss-process=image/resize,m_fill,h_160,w_160'" alt="" @click="preview(index)">
        </swiper-slide>
      </swiper>
    </section>
    <footer class="footer-fixed flex all-c van-hairline--top" v-if="!show">
         <van-button
        type="default" class="flex-1  radius-0"
        :disabled="!recruit.dispatchButton"
        @click="goQuickInterview">
        <span class="f16 c-red" v-if="recruit.dispatchButton">{{quickviewmessage1}}</span>
        <span class="f16 c-white" v-if="!recruit.dispatchButton">{{quickviewmessage2}}</span>
      </van-button>
      <van-button
        type="primary" class="flex-1 btn-gradient radius-0"
        :disabled="!recruit.dispatchButton"
        v-if="recruit.dispatchButton"
        @click="confirmShare">
        <span class="f16">转发</span>
      </van-button>
      </footer>

    <!--  生成海报  -->
    <div id="share" style="position:fixed;right:-9999px;width:100%;top:0;">
      <div class="poster-title" style="border-radius:0">
        <img src="../../assets/images/poster/t-logo.png" class="poster-logo lb-vm"/>
      </div>
      <info :recruit="recruit" :showShare="true">
        <template #shareImg>
        <div class="txt-r">
        <img :src="codeData" @load="initCanvas" @error="initCanvas" class="qr pr25 pb10"/>
      </div>
      </template>
      </info>
    </div>
    <!--  生成海报  -->
    <div id="sharesmall" style="position:fixed;right:-7777px;width:100%;top:0;">
      <div class="poster-title" style="border-radius:0">
        <img src="../../assets/images/poster/t-logo.png" class="poster-logo lb-vm"/>
      </div>
      <infosmall :recruit="recruit" :showShare="true">
        <template #shareSmallImg>
        <div class="txt-r">
        <img :src="codeData2" @load="initCanvas2" @error="initCanvas2" class="qr pr25 pb10"/>
      </div>
      </template>
      </infosmall>
    </div>

    <van-dialog
              v-model="show"
              title="分享到"
              show-cancel-button :showConfirmButton=false
            >
                 <van-row type="flex" justify="center" class="mt19 mb20">
                      <van-col span="9" class="txt-c" @click.native="doShare(1)">
                        <p><img class="poster-img" src="../../assets/images/poster/wx.png"/></p>
                        <p class="pt8 f12 pb10">微信</p>
                      </van-col>
                      <van-col span="9" class="txt-c" @click.native="doShare(2)">
                        <p><img class="poster-img" src="../../assets/images/poster/pyq.png"/></p>
                        <p class="pt8 f12 pb10">朋友圈</p>
                      </van-col>
                </van-row>
            </van-dialog>
  </div>
</template>

<script>
  import infosmall from '../recruit/infosmall';
  import api from '../../api';
  import { ImagePreview } from 'vant';
  import html2canvas from 'html2canvas';
  import 'swiper/dist/css/swiper.css';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import recruit from '../../mixins/recruit';
  import login from '../../mixins/login';
  import info from './info';
  import { showMap, savePasteboard, shareWithApp, launchMiniProgram } from '../../libs/native-app';
  import {
  distanceDisplay, convertBase64ToBlob
} from '../../libs/util';

  const { EmployeeStatusColor, EmployeeStatus } = require('../../libs/config');

  export default {
    name: 'recruit-detail',
    mixins: [recruit, login],
    components: { info, swiper, swiperSlide, infosmall },
    data() {
      return {
        show: false,
        employeeColor: EmployeeStatusColor,
        employeeStatus: EmployeeStatus,
        swiperOption: { spaceBetween: 10, slidesPerView: 3.5 },
        recruit: { jobPayLower: 0, jobPayUpper: 0, imgUrls: [] },
        showDistance: null,
        showMore: true,
        empty: 0,
        personList: [],
        pickStatus: 0,
        quickviewmessage1: '快速添加面试',
        quickviewmessage2: '已招满',
        quickviewmessage3: '招聘未开始',
        personCount: 0,
        totalPersonNum: 0,
        titlePerson: '员工报名记录',
        loading: false,
        finished: false,
        Paging: { PageIndex: 1, PageSize: 3 },
        showIndex: -1,
        recruitCopy: '',
        codeData: '',
        canvasData: '',
        codeData2: null,
        lastScrollLength: 0,
        userName: '',
        mType: 0,
        shareType: 0
      };
    },
    computed: {
      // 备注HTML格式化
      remarkHtml() {
        const remark = this.recruit.remark || '';
        return remark.replace(/\n/g, '<br/>');
      }
    },
    mounted() {
      this.init();
      if (this.$route.query.dis) {
        let dis = this.$route.query.dis === -1 ? '' : distanceDisplay(this.$route.query.dis);
        this.showDistance = { Distance: dis };
      }
    },
    methods: {
      tabChange(index) {
        if (this.pickStatus === index) return;
        this.pickStatus = index;
        if (this.pickStatus === 1) {
          this.getPersonList(true);
        }
      },
      confirmShare() {
        this.checkShare(this.doConfirmShare);
      },
      doConfirmShare() {
        // 直接分享到微信，不再弹出选择框
        this.doShare(1);
      },
      // 跳转到快速添加面试页面，携带岗位信息
      goQuickInterview() {
        const r = this.recruit;
        // 构建性别限制名称
        let sexTypeLimitName = '不限';
        if (r.genderRequire === 1) sexTypeLimitName = '男性';
        if (r.genderRequire === 2) sexTypeLimitName = '女性';
        
        // 构建面试时间列表（转换成组件需要的格式）
        let interviewDateList = '';
        if (r.interviewDate && r.interviewDate.length > 0 && r.interviewTimes) {
          // interviewDate: [1,2,3] 表示周一、周二、周三
          // interviewTimes: "09:00-18:00" 表示面试时间段
          const weekMap = {
            1: '周一', 2: '周二', 3: '周三', 4: '周四',
            5: '周五', 6: '周六', 7: '周日'
          };
          
          // 解析时间段，生成时间选项
          const timeStr = r.interviewTimes || '09:00-18:00';
          const [startTime, endTime] = timeStr.split('-');
          const startHour = parseInt(startTime.split(':')[0]) || 9;
          const endHour = parseInt(endTime.split(':')[0]) || 18;
          
          // 生成每个小时的时间选项
          const timeOptions = [];
          for (let h = startHour; h <= endHour; h++) {
            timeOptions.push({ label: `${h.toString().padStart(2, '0')}:00` });
          }
          
          // 生成未来7天内符合面试日期的选项
          const today = new Date();
          const dateOptions = [];
          for (let i = 0; i < 14; i++) { // 查找未来14天
            const date = new Date(today);
            date.setDate(today.getDate() + i);
            const weekDay = date.getDay() || 7; // 周日是0，转成7
            if (r.interviewDate.includes(weekDay)) {
              const month = (date.getMonth() + 1).toString().padStart(2, '0');
              const day = date.getDate().toString().padStart(2, '0');
              const label = `${month}/${day} ${weekMap[weekDay]}`;
              dateOptions.push({
                label: label,
                children: timeOptions
              });
            }
          }
          
          if (dateOptions.length > 0) {
            interviewDateList = encodeURIComponent(JSON.stringify(dateOptions));
          }
        }
        
        // id 优先从 recruit 对象取，取不到则从路由参数取
        const recruitId = r.recruitDispatchRecordId || r.id || this.$route.query.id;
        
        const params = [
          `id=${recruitId}`,
          `type=${r.jobType}`,
          `positionName=${encodeURIComponent(r.title || '')}`,
          `sexType=${r.genderRequire || 0}`,
          `sexTypeLimitName=${encodeURIComponent(sexTypeLimitName)}`,
          `contractAddress=${encodeURIComponent(r.address || '')}`,
          `interviewAddress=${encodeURIComponent(r.interviewAddress || r.address || '')}`,
          `interviewDateList=${interviewDateList}`,
          `interviewTimes=${encodeURIComponent(r.interviewTimes || '')}`
        ];
        
        this.goShare(`quick-interview?${params.join('&')}`);
      },
      async init() {
        try {
          this.$loading();
          await this.getRecruitBySysNo();
          await this.getRecruitDescribe();
          // await this.getRecruitByInterviewerSysNo();
          await this.getPersonList();
        } catch (e) {
          this.$toast(e.message);
        }
      },
      async getRecruitBySysNo() {
        try {
          this.$loading();
          // 临时改用 GET 请求
          const id = this.$route.query.id;
          let result = await api.get(`/api/vpai/recruit/detail_by_id?recruitId=${id}`);
          // 处理返回数据
          this.recruit = result.data || result;
          // 临时写死 dispatchButton 为 true
          this.recruit.dispatchButton = true;
          this.recruitCopy = this.processRecruitCopyData(this.recruit);
          this.$loadingClose();
          this.$store.commit('updateRecruit', {
            RecruitSysNo: this.$route.query.id,
            LeftCount: this.recruit.leftCount || 0,
            ApplyCount: this.recruit.applyCount || 0,
            RecruitInstantStatus: this.recruit.dispatchButton ? 2 : 0,
            IsLeaderPick: this.recruit.dispatchButton === false ? 1 : 0
          });
        } catch (e) {
          this.$toast(e.message);
        }
      },
      // 获取岗位详情和面试地址时间
      async getRecruitDescribe() {
        try {
          const id = this.$route.query.id;
          // 获取经纬度，优先从路由参数获取，否则使用默认值0
          const lat = this.$route.query.lat || 0;
          const lng = this.$route.query.lng || 0;
          let result = await api.get(`/api/vpai/recruit/recruit_describe?id=${id}&lat=${lat}&lng=${lng}`);
          const describeData = result.data || result;
          // 将岗位详情和面试信息合并到 recruit 对象
          if (describeData) {
            this.recruit = {
              ...this.recruit,
              // 岗位详情（使用单独的 describe 字段，不要覆盖 remark）
              describe: describeData.describe,
              otherCertificate: describeData.otherCertificate,
              probation: describeData.probation,
              probationUnit: describeData.probationUnit,
              // 面试地址和时间
              interviewAddress: describeData.interviewAddress,
              interviewDate: describeData.interviewDate || [],
              interviewTimes: describeData.interviewTimes,
              interviewLat: describeData.inviteAddLat,
              interviewLng: describeData.inviteAddLng,
              // 距离
              describeDistance: describeData.distance
            };
          }
        } catch (e) {
          console.error('获取岗位详情失败:', e);
        }
      },
      async getPersonList(init = false) {
        try {
          if (init) this.Paging.PageIndex = 1;
          this.loading = true;
          const id = this.$route.query.id;
          let result = await api.post('/api/vpai/recruit/page_apply_record', {
            id: id,
            orderType: 0,
            pageNum: this.Paging.PageIndex,
            pageSize: 10
          });
          const list = result.data || [];
          if (init) {
            this.personList = list;
          } else {
            this.personList = [...this.personList, ...list];
          }
          this.personCount = list.length;
          this.$nextTick(() => {
            this.empty = list.length === 0 ? 10 : 0;
            this.totalPersonNum = this.personList.length;
            if (this.totalPersonNum) {
              this.titlePerson = '员工报名记录' + '(' + this.totalPersonNum + ')';
            }
            // 如果返回数量少于 pageSize，说明已加载完毕
            this.finished = list.length < 10;
            this.Paging.PageIndex++;
            this.loading = false;
          });
        } catch (e) {
          this.loading = false;
          this.finished = true;
          this.$error(e.message);
        }
      },
      preview(index) {
        ImagePreview({ images: this.recruit.imgUrls || [], startPosition: index });
      },
      showRemark(index) {
        if (this.personList[index].status === 12) {
          this.showIndex = this.showIndex === index ? -1 : index;
        }
      },
      // 格式化时间戳
      formatTime(timestamp) {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hour}:${minute}`;
      },
      goMap() {
        showMap({
          sellerName: this.recruit.storeName,
          dLng: this.recruit.lng,
          dLat: this.recruit.lat,
          sLng: 0,
          sLat: 0
        });
      },
      async doCopy() {

        let res = await savePasteboard(this.recruitCopy);
        console.log(this.recruitCopy);
        this.$toast.success('复制成功');
      },
      async getCodeData() {
        try {
          this.codeData2 = null;
          this.codeData = null;
          console.log('');
          const result = await api.get('/api/share/create_share_token', {
            params: {
              recruitDispatchRecordId: this.recruit.recruitDispatchRecordId || '',
              recruitId: this.recruit.id || ''
            }
          });
          // 接口返回格式：{ code: 10000, data: "token字符串" }
          let trackToken = '';
          if (result.code === 10000 && result.data) {
            trackToken = result.data;
          }
          if (this.shareType === 1) {
            this.codeData2 = trackToken;
            console.log(JSON.stringify(this.codeData2));
          } else {
            this.codeData = trackToken;
            console.log(JSON.stringify(this.codeData));
          }
        } catch (e) {
          this.$error(e.message);
        }
      },
      async initCanvas() {
        if (!this.recruit.RecruitSysNo) {
          this.$loadingClose();
          return;
        }
        this.initCanvasDraw();
      },
      async initCanvasDraw() {
        setTimeout(() => {
          this.initCanvasDrawDo();
        }, 1000);
      },
      async initCanvasDrawDo() {
        if (this.shareType === 1) {
            let canvas = await html2canvas(document.getElementById('sharesmall'), { scale: 2 });
            this.canvasData = canvas.toDataURL('image/jpeg');
          } else {
            let canvas = await html2canvas(document.getElementById('share'), { scale: 2 });
            this.canvasData = canvas.toDataURL('image/jpeg');
          }
          console.log(this.canvasData);
          console.log('this.canvasData1');
          window.scrollTo(0, this.lastScrollLength);
          this.lastScrollLength = 0;
          this.$loadingClose();
          if (this.shareType > 0) {
            this.share(this.shareType);
          }
      },
      async initCanvas2() {
        if (!this.recruit.RecruitSysNo) {
          this.$loadingClose();
          return;
        }
      },
      initCanvas2Draw() {
        setTimeout(() => {
          this.initCanvas2DrawDo();
        }, 1000);
      },
      async initCanvas2DrawDo() {
        if (this.shareType === 1) {
            let canvas = await html2canvas(document.getElementById('sharesmall'), { scale: 2 });
            this.canvasData = canvas.toDataURL('image/jpeg');
          } else {
            let canvas = await html2canvas(document.getElementById('share'), { scale: 2 });
            this.canvasData = canvas.toDataURL('image/jpeg');
          }
          console.log(this.canvasData);
          console.log('this.canvasData2');
          window.scrollTo(0, this.lastScrollLength);
          this.lastScrollLength = 0;
          this.$loadingClose();
          if (this.shareType > 0) {
            this.share(this.shareType);
          }
      },
      async doShare(shareType) {
        try {
          this.$loading("准备分享...");
          this.shareType = shareType;

          const recruitItem = this.recruit;
          // 优先使用 recruit.id，如果没有则从路由参数获取
          const recruitId = recruitItem.id || recruitItem.recruitId || this.$route.query.id;
          if (!recruitId) {
            this.$loadingClose();
            this.$toast("未找到招聘信息");
            return;
          }

          // 1. 调用接口获取分享追踪令牌
          const tokenResult = await api.get("/api/share/create_share_token", {
            params: {
              recruitDispatchRecordId: recruitItem.recruitDispatchRecordId || "",
              recruitId: recruitId,
            },
          });

          // 获取追踪Token
          let trackToken = "";
          if (tokenResult.code === 10000 && tokenResult.data) {
            trackToken = tokenResult.data;
          }
          console.log("分享追踪Token:", trackToken);

          // 检查环境
          const ua = navigator.userAgent;
          const isWxmp = ua.toLowerCase().indexOf('miniprogram') > -1;

          if (shareType === 1) {
            // 微信好友分享
            if (isWxmp) {
              // 小程序环境：跳转到小程序分享页面
              launchMiniProgram({
                appId: "wxbb140f2dced7d207",
                path: `subPackages/aboutPost/pages/post_detail/share?id=${recruitId}&shareToken=${trackToken}&shareFlag=true`,
                envVersion: "trial",//release
              });
              this.$loadingClose();
              this.show = false;
              return;
            } else {
              // APP环境：分享小程序卡片
              const miniPath = `subPackages/aboutPost/pages/post_detail/share?id=${recruitId}&shareToken=${trackToken}&IsFromShare=1`;
              const shareObj = {
                shareMedia: 3, // 3-小程序卡片
                shareType: 1, // 1-微信好友
                title: `就业队长招聘${recruitItem.title || ""}`,
                imgUrl: recruitItem.imgUrls && recruitItem.imgUrls[0] ? recruitItem.imgUrls[0] : "",
                imageUrl: recruitItem.imgUrls && recruitItem.imgUrls[0] ? recruitItem.imgUrls[0] : "",
                userName: "gh_49bd5402050d",
                path: miniPath,
                mType: 0, // 0-正式版
              };
              await shareWithApp(shareObj);
              this.$loadingClose();
              this.show = false;
              return;
            }
          } else if (shareType === 2) {
            // 朋友圈分享 - 使用海报分享流程
            this.getCodeData(shareType);
          }
        } catch (e) {
          this.$loadingClose();
          this.show = false;
          console.error("分享失败:", e);
          this.$toast(e.message || "分享失败");
        }
      },
      async share(index) {
        try {
          if (!this.recruit.RecruitSysNo) {
            return;
          }
          this.$loading('请稍后', 3000);
          await this.$store.dispatch('postData', {
            url: '/recruit/LeaderPickRecruit',
            data: {
              Body: {
                RecruitSysNo: this.recruit.RecruitSysNo,
                PersonSysNo: this.$store.state.person.PersonSysNo
              }
            }
          });
          if (this.recruit) {
            this.recruit.IsLeaderPick = 1;
            this.$store.commit('updateRecruit', {
              RecruitSysNo: this.$route.query.id,
              LeftCount: this.recruit.LeftCount,
              ApplyCount: this.recruit.ApplyCount,
              RecruitInstantStatus: this.recruit.RecruitInstantStatus,
              IsLeaderPick: this.recruit.IsLeaderPick
            });
          }
          if (index === 1) {
            this.getShareData(this.recruit.RecruitSysNo);
          } else {
            try {
              await shareWithApp({
                imgUrl: this.canvasData,
                shareType: index,
                shareMedia: 2
              });
            this.$loadingClose();
            } catch (e) {
              this.show = false;
              this.$toast(e.message);
            }
          }
        } catch (e) {
          this.$toast(e.message);
        }
      },
      async getShareData(id) {
        try {
          // 获取分享参数
          if (!this.userName) {
            let res = await this.$store.dispatch('postData', {
              url: '/recruit/GetShareData',
              data: {}
            });
            recruit.IsLeaderPick = 1;
            console.log('getShareData:', res);
            this.userName = res.username;
            this.mType = parseInt(res.mtype);
            this.doShareLittleApp(id);
          } else {
            this.doShareLittleApp(id);
          }
        } catch (e) {
          this.$toast(e);
        }
      },
      async doShareLittleApp(id) {
          let file = convertBase64ToBlob(this.canvasData);
          let formData = new FormData();
          formData.append('folder', 'authen');
          formData.append('file[]', file);
          const config = {
            headers: { 'Content-Type': 'multipart/form-data' }
          };
          let ossRes = await api.post(`/upload/upload-images`, formData, config);
          console.log(ossRes.Data[0].url);
          if (ossRes && ossRes.Data && ossRes.Data.length > 0) {
            // 分享小程序卡片
              let path = '';
              path = `pages/v2/applicant-job-detail/main?RecruitSysNo=${id}&LeaderPersonSysNo=${this.$store.state.person.PersonSysNo}&FromPersonSysNo=${this.$store.state.person.PersonSysNo}&IsFromShare=1&t=2`;
              // if (this.$store.state.person.LeaderPersonSysNo) {
              //   path = `pages/v2/applicant-job-detail/main?RecruitSysNo=${id}&LeaderPersonSysNo=${this.$store.state.person.LeaderPersonSysNo}&FromPersonSysNo=${this.$store.state.person.LeaderPersonSysNo}&IsFromShare=1&t=2`;
              // } else {
              //   path = `pages/v2/applicant-job-detail/main?RecruitSysNo=${id}&FromPersonSysNo=${this.$store.state.person.PersonSysNo}&IsFromShare=1&t=2`;
              // }
              let shareObj = {
                shareMedia: 3,
                shareType: 1,
                imgUrl: ossRes.Data[0].url,
                imageUrl: ossRes.Data[0].url,
                link: 'http://www.baidu.com',
                title: `就业队长招聘${this.recruit.PositionName}`,
                userName: this.userName,
                path: path,
                mType: this.mType
              };
              try {
              await shareWithApp(shareObj);
              this.$loadingClose();
            } catch (e) {
              this.show = false;
              this.$toast(e.message);
            }
          } else {
            this.$loadingClose();
          }
      }
    }
  };
</script>

<style lang="less">
  @import '../../assets/css/theme.less';
  .van-nav-bar__text {
    color: #000000;
  }
  .van-tab--active {
    font-weight: bold;
  }

  .detail-single-line-tabs .van-hairline--top-bottom::after {
    border-width: 0 0 0.02667rem 0;
    border-color: #ffffff transparent #d2d6d5 transparent;
  }

  .job-detail .swiper-slide img {
    width: 90px;
    height: 90px;
    overflow: hidden;
  }

  .job-detail .footer-fixed .van-button {
    padding: 0 1rem;
  }

  .job-refect-tip {
    left: 80px;
  }

  .job-refect-tip .tip-content {
    min-width: 100px;
  }

  .zw-detail {
    line-height: 21px;
    margin: 15px 25px;
  }
  .job-detail .footer-fixed .van-button--default{ border: 0;}
  .job-detail .footer-fixed .van-button--default::after{ display: none;}
  .ds-job-list-box{ box-shadow: none;}
  .detail-store p.img-auto{ width: 64px; height: 64px; overflow: hidden; border-radius:4px; margin-right:18px; }
  .detail-store p.img-auto img{ width: 100%; height: 100%;}
  .detail-store .flex-1{ width: 0; padding-right: 18px; }
  .qr {
    width: 120px;
    height: 120px;
  }
   .poster-img {
    width: 44px;
    height: 44px;
  }
  .poster-title {
    height: 41px;
    line-height: 41px;
    border-radius: 5px 5px 0 0;
    background: linear-gradient(146deg, rgba(255, 134, 58, 1) 0%, rgba(253, 100, 4, 1) 100%);
  }

  .poster-logo {
    height: 40px;
    width: auto;
    margin-left: 10px;
  }

 .ds-address-detail {
    line-height: 1.4;
    padding: 10px 0;
  }

  .ds-address-detail .flex-1 {
    padding: 0 8px;
  }

</style>
